<template>
    <div class="vehicle-owner-short-info">
        <div class="vehicle-owner-short-info__rented-by">
            <strong>{{ $t('vehicle_info.is_rented_by') }}</strong>
            <OrganizationLogo v-if="user.isOrganizationRepresentative" :user="user" />
            <Avatar v-else :user="user" :selectable="true" />
            <a :href="generateLink('vehicle-owner')" @click.prevent="$emit('link-clicked', 'vehicle-owner')">
                {{ displayName }}
            </a>
        </div>

        <div class="vehicle-owner-short-info__wrapper">
            <OrganizationLogo v-if="user.isOrganizationRepresentative" :user="user" />
            <Avatar v-else :user="user" :selectable="true" />

            <div class="vehicle-owner-short-info__verifications">
                <div
                    v-if="user.isIdVerified || !user.isBaloiseMarket"
                    class="vehicle-owner-short-info__verifications__item"
                >
                    <svg-icon name="account_check_outline" />
                    <span v-if="user.isIdVerified">
                        {{ $t('user_verifications.verified_owner') }}
                    </span>
                    <span v-else-if="!user.isBaloiseMarket">
                        {{ $t('user_verifications.not_verified_owner') }}
                    </span>
                </div>
                <div v-if="user.topOwner" class="vehicle-owner-short-info__verifications__item">
                    <svg-icon name="social_leaderboard" />
                    <span>
                        {{ $t('user_verifications.top_owner') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '~/components/Avatar';
import OrganizationLogo from '~/components/OrganizationLogo';
export default {
    name: 'VehicleOwnerShortInfo',
    components: { OrganizationLogo, Avatar },
    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        displayName() {
            if (!this.user.isOrganizationRepresentative || !this.organization.name) {
                return this.user.name;
            }

            if (this.forceShowUser) {
                return `${this.user.firstName} på ${this.organization.name}`;
            }

            return this.organization.name;
        },
        organization() {
            if (!this.user.isOrganizationRepresentative) {
                return {};
            }

            return {
                name: this.user.organizationName,
                logoUrl: this.user.organizationLogotypeUrl,
            };
        },
    },
    methods: {
        generateLink(sectionName) {
            const fullPath = this.$route.fullPath.replace(/#.*/, ''); // remove hash value

            return this.$config.siteUrl ? `${this.$config.siteUrl}${fullPath}#${sectionName}` : `#${sectionName}`;
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.vehicle-owner-short-info {
    @extend %card;
    padding: 16px;

    &__rented-by {
        white-space: nowrap;

        @media screen and (max-width: $bp-xl-min) {
            strong {
                margin-right: 4px;
            }

            .avatar-wrapper,
            .organization-logo {
                display: none;
            }
        }

        a {
            white-space: nowrap;
        }

        @include lg {
            display: flex;
            align-items: center;
        }
    }

    ::v-deep .avatar,
    .organization-logo {
        width: 56px;
        height: 56px;

        @include xl {
            margin: 0 8px;
        }
    }

    .avatar-wrapper {
        height: 56px;
    }

    &__wrapper {
        display: flex;
        margin-top: 16px;

        @include xl {
            margin: 0;
            align-items: center;

            .avatar-wrapper,
            .organization-logo {
                display: none;
            }
        }
    }

    &__verifications {
        margin-left: 24px;
        font-weight: 600;

        &__item {
            display: flex;
            align-items: center;

            &:not(:last-child) {
                margin-bottom: 8px;

                @include xl {
                    margin: 0 24px 0 0;
                }
            }

            @include xl {
                max-width: 275px;
            }
        }

        .svg-icon {
            width: 24px;
            height: 24px;
            min-width: 24px;
            margin-right: 8px;
        }

        @include xl {
            display: flex;
            margin-left: 40px;
        }
    }

    @include xl {
        display: flex;
    }
}
</style>
